import { Component, OnInit, OnDestroy } from '@angular/core';
import { Journal } from '../../interfaces/journal-page';
import { JournalPost } from '../../interfaces/journal-post';
import { ActivatedRoute } from '@angular/router';
import { MetaDataService } from '../../services/metadata.service';
import { WordpressService } from '../../services/wordpress.service';
import { map } from 'rxjs/operators';
import * as $ from 'jquery';

@Component({
  selector: 'app-page-journal',
  templateUrl: './page-journal.component.html',
  styleUrls: ['./page-journal.component.scss']
})
export class PageJournalComponent implements OnInit, OnDestroy {
  page$;
  post$;
  $html;
  $body;
  $wp;
  content: Journal;
  posts: JournalPost[];
  currentPage = 1;
  totalPages;
  showMore = false;

  constructor(
    private route: ActivatedRoute,
    private mds: MetaDataService,
    private wps: WordpressService
  ) {
    // Get page content
    this.page$ = this.route.data.pipe(map(r => r.content));
    this.page$.subscribe(page => {
      this.content = page;

      // set metadata
      this.mds.setMetaData(this.content);
    });

    // Get posts
    this.post$ = this.route.data.pipe(map(r => r.posts));
    this.post$.subscribe(res => {
      if (res) {
        this.posts = res.posts;

        // Determine if there are multiple pages
        this.totalPages = parseFloat(res.totalPage);
        this.showMore = this.totalPages > this.currentPage;
      }
    });
  }

  getMorePosts() {
    // Grab next page of posts and determine if there are still more to grab
    this.currentPage = this.currentPage + 1;
    this.showMore = this.totalPages > this.currentPage;

    this.$wp = this.wps.getJournalPosts(this.currentPage).subscribe(res => {
      if (!res || !res.body) {
        return;
      }

      this.posts = this.posts.concat(res.body);
    });
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.$html = $('html');
    this.$body = $('body');
    this.$html.removeClass('no-scroll');
    this.$body.removeClass('no-scroll');
  }

  ngOnDestroy() {
    if (this.page$) {
      this.page$.unsubscribe();
    }

    if (this.post$) {
      this.post$.unsubscribe();
    }

    if (this.$wp) {
      this.$wp.unsubscribe();
    }
  }
}
